var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M29,0c0,0-6.667,8-22,8v19.085c0,9.966,4.328,19.577,12.164,25.735C21.937,55,25.208,56.875,29,58 c3.792-1.125,7.062-3,9.836-5.18C46.672,46.662,51,37.051,51,27.085V8C35.667,8,29,0,29,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b22e2e"
    },
    d: "M29,51.661c-2.123-0.833-4.178-2.025-6.128-3.558C16.69,43.245,13,35.388,13,27.085V13.628 c7.391-0.943,12.639-3.514,16-5.798c3.361,2.284,8.609,4.855,16,5.798v13.457c0,8.303-3.69,16.16-9.871,21.018 C33.178,49.636,31.123,50.828,29,51.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M20,39c-0.247,0-0.494-0.091-0.688-0.274c-0.401-0.38-0.418-1.013-0.039-1.414l18-19 c0.38-0.402,1.013-0.418,1.414-0.039c0.401,0.38,0.418,1.013,0.039,1.414l-18,19C20.529,38.896,20.265,39,20,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39,39c-0.256,0-0.512-0.098-0.707-0.293l-19-19c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l19,19c0.391,0.391,0.391,1.023,0,1.414C39.512,38.902,39.256,39,39,39z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifFail);
export default __webpack_public_path__ + "static/media/verifFail.e51975fbe5cce9d998cd98a5bac92a9a.svg";
export { ForwardRef as ReactComponent };